(function () {
  var root = document.querySelector('[data-mm-orders]');
  if (!root) return;

  var PROXY_PATH = '/apps/billing';
  var WHATSAPP = String(root.getAttribute('data-mm-whatsapp') || '').replace(/\D/g, '');
  var list = root.querySelector('[data-mm-orders-list]');
  if (!list) return;
  var PREVIEW_ITEMS = 3;

  // Shopify's App Proxy occasionally forwards an empty logged_in_customer_id
  // for a logged-in customer (the backend answers 403); retry once.
  function callApi(action, attempt) {
    return fetchApi(action).catch(function (error) {
      if ((attempt || 0) >= 3) throw error;
      return new Promise(function (resolve) { setTimeout(resolve, 800 * ((attempt || 0) + 1)); }).then(function () {
        return callApi(action, (attempt || 0) + 1);
      });
    });
  }

  function fetchApi(action) {
    return fetch(PROXY_PATH + '?action=' + encodeURIComponent(action) + '&limit=200&_=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) throw new Error((body && (body.message || body.exception)) || 'Request failed');
        return body && body.message !== undefined ? body.message : body;
      });
    });
  }

  function money(amount) {
    var value = Number(amount || 0);
    return (value < 0 ? '-' : '') + '₹' + Math.abs(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function dateLabel(value) {
    if (!value) return '—';
    var d = new Date(value);
    if (isNaN(d.getTime())) return String(value || '');
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function waIcon() {
    var span = document.createElement('span');
    span.innerHTML = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.4 8.4 0 0 1-3.8-.9L3 21l2-5.2a8.4 8.4 0 1 1 16-4.3z"/></svg>';
    return span.firstChild;
  }

  function normalizeOrderNo(value) {
    return String(value || '').replace(/^#/, '').trim().toLowerCase();
  }

  function statusClass(order) {
    return order.cancelled ? 'is-cancelled' : /deliver/i.test(order.status_label) ? 'is-shipped' : 'is-processing';
  }

  function itemRow(item) {
    var row = el('div', 'mm-orders__item');
    var thumb = el('div', 'mm-orders__thumb');
    thumb.setAttribute('aria-hidden', 'true');
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image; img.alt = ''; img.width = 64; img.height = 80; img.loading = 'lazy';
      thumb.appendChild(img);
    }
    row.appendChild(thumb);
    var main = el('div', 'mm-orders__item-main');
    main.appendChild(el('span', 'mm-orders__item-title', item.item_name));
    main.appendChild(el('span', 'mm-orders__item-meta', 'Qty ' + item.qty + ' × ' + money(item.rate) + ' = ' + money(item.amount)));
    row.appendChild(main);
    return row;
  }

  // ---- ERPNext order detail view (dialog / bottom sheet on phones) ----
  var dialog = null;

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'mm-dialog';
    dialog.innerHTML =
      '<div class="mm-dialog__head"><div data-mm-dialog-title></div><button type="button" class="mm-dialog__close" aria-label="Close">&times;</button></div>' +
      '<div class="mm-dialog__body" data-mm-dialog-body></div>' +
      '<div class="mm-dialog__foot" data-mm-dialog-foot></div>';
    dialog.querySelector('.mm-dialog__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function openOrder(order) {
    var d = ensureDialog();
    var items = order.items || [];
    var title = d.querySelector('[data-mm-dialog-title]');
    title.innerHTML = '';
    title.appendChild(el('span', 'mm-dialog__eyebrow', 'Store order'));
    title.appendChild(el('h2', 'mm-dialog__title', order.name));
    var meta = el('div', 'mm-dialog__meta');
    meta.appendChild(el('span', null, 'Placed ' + dateLabel(order.date)));
    if (order.delivery_date) meta.appendChild(el('span', null, 'Delivery ' + dateLabel(order.delivery_date)));
    meta.appendChild(el('span', 'mm-orders__chip ' + statusClass(order), order.status_label));
    title.appendChild(meta);

    var body = d.querySelector('[data-mm-dialog-body]');
    body.innerHTML = '';
    var table = document.createElement('table');
    table.className = 'mm-dialog__table';
    table.innerHTML = '<thead><tr><th>Item</th><th class="num">Qty</th><th class="num">Rate</th><th class="num">Amount</th></tr></thead>';
    var tbody = document.createElement('tbody');
    items.forEach(function (item, index) {
      var tr = document.createElement('tr');
      var name = document.createElement('td');
      name.appendChild(el('span', 'mm-dialog__idx', String(index + 1) + '. '));
      name.appendChild(document.createTextNode(item.item_name));
      if (item.item_code && item.item_code !== item.item_name) name.appendChild(el('small', null, item.item_code));
      tr.appendChild(name);
      tr.appendChild(el('td', 'num', String(item.qty)));
      tr.appendChild(el('td', 'num', money(item.rate)));
      tr.appendChild(el('td', 'num', money(item.amount)));
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    var tfoot = document.createElement('tfoot');
    var total = document.createElement('tr');
    total.appendChild(el('td', null, items.length + ' item' + (items.length === 1 ? '' : 's')));
    total.appendChild(el('td', 'num', String(items.reduce(function (sum, item) { return sum + Number(item.qty || 0); }, 0))));
    total.appendChild(el('td', null, ''));
    total.appendChild(el('td', 'num mm-dialog__total', money(order.total)));
    tfoot.appendChild(total);
    table.appendChild(tfoot);
    body.appendChild(table);

    var foot = d.querySelector('[data-mm-dialog-foot]');
    foot.innerHTML = '';
    if (WHATSAPP) {
      var help = document.createElement('a');
      help.className = 'mm-orders__btn mm-orders__btn--wa';
      help.target = '_blank'; help.rel = 'noopener';
      help.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent('Help with store order ' + order.name);
      help.appendChild(waIcon());
      help.appendChild(document.createTextNode(' Help / Return on WhatsApp'));
      foot.appendChild(help);
    }
    var close = el('button', 'mm-orders__btn mm-orders__btn--ghost', 'Close');
    close.type = 'button';
    close.addEventListener('click', function () { d.close(); });
    foot.appendChild(close);

    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }

  // Same card as the Liquid-rendered Shopify orders, built from an ERPNext
  // Sales Order that Shopify never saw (a store / wholesale order).
  function buildCard(order) {
    var items = order.items || [];
    var card = el('article', 'mm-orders__card' + (order.cancelled ? ' is-muted' : ''));
    card.setAttribute('data-mm-order', '');
    card.setAttribute('data-order-date', String(order.date || ''));
    card.setAttribute('data-order-name', order.name);

    var head = el('div', 'mm-orders__card-head');
    var meta = el('div', 'mm-orders__card-meta');
    meta.appendChild(el('span', 'mm-orders__name', order.name));
    meta.appendChild(el('span', null, 'Placed ' + dateLabel(order.date)));
    meta.appendChild(el('span', null, items.length + ' item' + (items.length === 1 ? '' : 's')));
    meta.appendChild(el('span', 'mm-orders__source', 'Store order'));
    head.appendChild(meta);
    var right = el('div', 'mm-orders__card-right');
    right.appendChild(el('span', 'mm-orders__chip ' + statusClass(order), order.status_label));
    right.appendChild(el('span', 'mm-orders__total', money(order.total)));
    head.appendChild(right);
    card.appendChild(head);

    var itemsWrap = el('div', 'mm-orders__items');
    items.slice(0, PREVIEW_ITEMS).forEach(function (item) { itemsWrap.appendChild(itemRow(item)); });
    if (items.length > PREVIEW_ITEMS) {
      var more = el('p', 'mm-orders__note', '+ ' + (items.length - PREVIEW_ITEMS) + ' more item' + (items.length - PREVIEW_ITEMS === 1 ? '' : 's') + ' — open View order for the full list');
      itemsWrap.appendChild(more);
    }
    card.appendChild(itemsWrap);

    var btns = el('div', 'mm-orders__btns');
    var view = el('button', 'mm-orders__btn mm-orders__btn--primary', 'View order');
    view.type = 'button';
    view.addEventListener('click', function () { openOrder(order); });
    btns.appendChild(view);
    if (WHATSAPP) {
      var help = document.createElement('a');
      help.className = 'mm-orders__btn mm-orders__btn--wa';
      help.target = '_blank'; help.rel = 'noopener';
      help.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent('Help with store order ' + order.name);
      help.appendChild(waIcon());
      help.appendChild(document.createTextNode(order.cancelled ? ' Ask about this order' : ' Help / Return on WhatsApp'));
      btns.appendChild(help);
    }
    card.appendChild(btns);
    return card;
  }

  // A Shopify order that ERPNext has synced is ONE order: keep Shopify's card
  // and print the ERPNext Sales Order number (and status) on it.
  function annotate(card, erpOrder) {
    var slot = card.querySelector('[data-mm-erp-ref]');
    if (!slot) return;
    slot.textContent = 'ERP ' + erpOrder.name + ' · ' + erpOrder.status_label;
    slot.hidden = false;
  }

  // Insert ERPNext-only orders between the Shopify cards by date. Shopify's
  // list is paginated, so an ERPNext order only lands on the page whose date
  // range covers it: newer than everything here -> page 1 (top), older ->
  // the last page (bottom).
  function merge(orders) {
    var page = Number(list.getAttribute('data-mm-page') || 1);
    var pages = Number(list.getAttribute('data-mm-pages') || 1);
    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-mm-order]'));
    var newest = cards.length ? cards[0].getAttribute('data-order-date') : null;
    var oldest = cards.length ? cards[cards.length - 1].getAttribute('data-order-date') : null;
    orders.forEach(function (order) {
      var date = String(order.date || '');
      if (!cards.length) { list.appendChild(buildCard(order)); return; }
      if (date > newest) { if (page === 1) list.insertBefore(buildCard(order), list.firstChild); return; }
      if (date < oldest) { if (page === pages) list.appendChild(buildCard(order)); return; }
      var before = null;
      for (var i = 0; i < cards.length; i += 1) {
        if (cards[i].getAttribute('data-order-date') <= date) { before = cards[i]; break; }
      }
      list.insertBefore(buildCard(order), before);
    });
  }

  callApi('orders')
    .then(function (result) {
      var all = (result && result.orders) || [];
      var cards = Array.prototype.slice.call(list.querySelectorAll('[data-mm-order]'));
      var byShopifyNo = {};
      cards.forEach(function (card) { byShopifyNo[normalizeOrderNo(card.getAttribute('data-order-name'))] = card; });

      var storeOrders = [];
      all.forEach(function (order) {
        if (order.marketplace === 'SHOPIFY') {
          var card = byShopifyNo[normalizeOrderNo(order.marketplace_order_number)];
          if (card) annotate(card, order);
          return;
        }
        storeOrders.push(order);
      });
      if (!storeOrders.length) return;

      merge(storeOrders);
      var empty = root.querySelector('[data-mm-orders-empty]');
      if (empty) empty.hidden = true;
      var countEl = root.querySelector('[data-mm-orders-count]');
      if (countEl) {
        var shopifyCount = Number(countEl.getAttribute('data-mm-shopify-count') || 0);
        countEl.textContent = String(shopifyCount + storeOrders.length);
      }
      var sub = root.querySelector('[data-mm-orders-sub]');
      if (sub) {
        sub.textContent = storeOrders.length + ' store order' + (storeOrders.length === 1 ? '' : 's') + ' from your business account are included.';
        sub.hidden = false;
      }
    })
    .catch(function () {
      // Not linked to ERPNext, or ERPNext unreachable: Shopify's list stands on its own.
    });
})();
